import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScalewayComponent } from './simple-icons-scaleway.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScalewayComponent ],
    exports:      [ SimpleIconsScalewayComponent ],
    bootstrap:    []
})
export class SimpleIconsScalewayModule {}
